import { useSessionContext } from 'features/auth';
import { createContext, ReactNode, useContext, useMemo } from 'react';

import { useGetUser } from './use-cases';
import { useGetMenu } from './use-cases/get-menu';
import { useGetRolePermissionList } from './use-cases/get-permission';
export type ContextValue =
  | { user: undefined; status: 'error' }
  | { user: undefined; status: 'loading' }
  | { user: any; status: 'success' };

export const UserContext = createContext<any | null>(null);
export const useUserContext = () => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error(
      'You tried to use UserContext outside the scope of the UserContextProvider.',
    );
  }

  return context;
};
export function UserContextProvider({ children }: { children: ReactNode }) {
  const { data } = useSessionContext();
  const userQueryResult: any = useGetUser(data?.userId as string, {
    enabled: Boolean(data?.userId),
    retry: false,
    onError: (error) => {
      console.error(error);
    },
  });

  const userValue = userQueryResult?.data?.rc[0];
  const filteredData: any = userQueryResult?.data?.rc?.filter(
    (item: any) => item.IsDefault === true,
  );
  const userFilterValue =
    filteredData?.length > 0 ? filteredData?.[0] : userValue;
  const companyId =
    filteredData?.length > 0
      ? filteredData?.[0]?.CompanyId
      : userValue?.CompanyId;
  const RoleIdValue =
    filteredData?.length > 0 ? filteredData?.[0]?.RoleId : userValue?.RoleId;
  const userQueryResultMenu: any = useGetMenu(companyId, {
    enabled: Boolean(companyId),
  });
  const userQueryResultPersmission: any = useGetRolePermissionList({
    // RoleId: userQueryResult?.data?.rc[0]?.RoleId,
    RoleId: RoleIdValue,
    enabled: Boolean(userQueryResult?.data?.rc[0]?.RoleId),
    UserType: 2,
    retry: false,
  } as any);
  const contextValue = useMemo(
    () =>
      ({
        status: userQueryResult.status,
        user: userFilterValue,
        menuItem: userQueryResultMenu?.data,
        permissions: userQueryResultPersmission?.data,
        companyUser: userQueryResult?.data,
      } as ContextValue),
    [
      userQueryResult.status,
      userFilterValue,
      userQueryResultMenu?.data,
      userQueryResultPersmission?.data,
      userQueryResult?.data,
    ],
  );

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
}
